import * as React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Slide,
} from "@material-ui/core";
import { TransitionProps } from "@material-ui/core/transitions";

interface IProps {
  dialogTitle?: string;
  message?: string;
}

interface IState {
  open: boolean;
}

const TransitionConst = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class ErrorResponse extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      open: true,
    };

    this.handleClose = this.handleClose.bind(this);
  }

  public render() {
    return (
      <Grid>
        {this.props.message && (
          <Dialog
            open={this.state.open}
            TransitionComponent={TransitionConst}
            keepMounted
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            onClose={this.handleClose}
          >
            <DialogTitle id="alert-dialog-slide-title">
              {this.props.dialogTitle}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                {this.props.message}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose} color="primary">
                Close
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </Grid>
    );
  }

  public handleClose() {
    this.setState({ open: false });
  }
}

export default ErrorResponse;
